import React, { forwardRef, useCallback } from 'react'
import { Editor as RdwEditor } from 'react-draft-wysiwyg'

import 'react-draft-wysiwyg/dist/react-draft-wysiwyg.css'
import 'assets/styles/Rdw/rdw.cleanui.scss'

const MessageEditor = ({
  setRef,
  editorState,
  editorStateChangeHandler,
  wrapperClassName,
  toolbarHidden,
  ...props
}) => {
  const pastedTextHandler = useCallback((text) => {
    return text
  }, [])

  return (
    <RdwEditor
      editorRef={setRef}
      editorState={editorState}
      toolbarHidden={toolbarHidden}
      toolbarClassName="rdw-custom-toolbar-wrapper"
      editorClassName={
        toolbarHidden ? 'rdw-custom-editor-wrapper rdw-hidden' : 'rdw-custom-editor-wrapper'
      }
      wrapperClassName={!wrapperClassName ? 'rdw-custom-wrapper' : wrapperClassName}
      onEditorStateChange={editorStateChangeHandler}
      toolbar={{
        options: ['inline', 'list', 'fontSize'],
        inline: {
          options: ['bold', 'italic', 'underline', 'strikethrough'],
        },
        list: {
          options: ['unordered', 'ordered'],
        },
        fontSize: {
          options: [8, 9, 10, 11, 12, 14, 16, 18, 24, 30, 36, 48],
        },
      }}
      handlePastedText={pastedTextHandler}
      {...props}
    />
  )
}

export default forwardRef((props, ref) => <MessageEditor {...props} setRef={ref} />)
